<template>
  <div>
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div class="bsd_main">
      <div class="bsd_hed">
        <div class="bsd_cnt">
          <div class="title">
            <div class="d1">所属店铺</div>
            <div class="d4" @click="storeList.length > 1 && (storeVisible = true)">
              <span style="vertical-align:middle">{{formInline.shopName}}</span>
              <van-icon v-show="storeList.length > 1" style="vertical-align: middle;" name="arrow" color="#999999" size="20"/>
            </div>
          </div>
        </div>
      </div>
      <ul class="bsd_mov">
        <li @click="handleChange('1')">今天 <div v-show="formInline.time == '1'"></div></li>
        <li @click="handleChange('5')">本周 <div v-show="formInline.time == '5'"></div></li>
        <li @click="handleChange('6')">本月 <div v-show="formInline.time == '6'"></div></li>
        <li @click="handleChange('7')">本季度 <div v-show="formInline.time == '7'"></div></li>
      </ul>
      <div class="bsd_hed">
        <div class="bsd_cnt">
          <div class="title mar5">
            <div class="d1 c9" v-if="!formatYM">{{timeFormInline[formInline.time]}}</div>
            <div class="d1 c9 rg_w" v-if="formatYM">{{formatYM}}</div>
            <div class="d3" @click="visibleTimer = !visibleTimer">
              <span style="vertical-align:middle">筛选</span>
              <img v-if="!visibleTimer" style="vertical-align:middle" class="img1" :src="icon1" />
              <img v-if="visibleTimer" style="vertical-align:middle" class="img1" :src="icon2" />
            </div>
          </div>
          <div class="title">
            <div class="d1">
              <div>销售统计</div>
              <div class="d2" @click="bvisible = !bvisible">规则说明<van-icon name="question-o" color="red" /></div>
            </div>
            <div class="d3">
              <span style="vertical-align:middle" @click.once="$router.push({name:'bees-sale-data-info'})">{{$theme.system_text_shoppers}}订单明细</span>
              <van-icon style="vertical-align: middle;" name="arrow" color="#999999" size="20"/>
            </div>
          </div>
          <ul class="cont">
            <li class="li" v-for="(item,index) in list_saleStatistics" :key="index">
              <p class="title cont-title">{{item.name}}</p>
              <p class="text" v-if="isNaN(item.count.substr(item.count.length -1))">
                {{item.count.substr(0, item.count.length -1)}}
                <span class="danwei">{{item.count.substr(item.count.length -1)}}</span>
              </p>
              <p v-else class="text">{{item.count}}</p>
            </li>
          </ul>
        </div>
        <div class="bsd_cnt bsd_mr10">
          <div class="title">
            <div class="d1">售后统计</div>
          </div>
          <ul class="cont">
            <li class="li" v-for="(item,index) in list_afterSaleStatistics" :key="index">
              <p class="title">{{item.name}}</p>
              <p class="text" v-if="isNaN(item.count.substr(item.count.length -1))">
                {{item.count.substr(0, item.count.length -1)}}
                <span class="danwei">{{item.count.substr(item.count.length -1)}}</span>
              </p>
              <p v-else class="text">{{item.count}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <van-popup
      v-model="bvisible"
      lock-scroll
      closeable
      round
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <BOOK @closecallback="bvisible = false"></BOOK>
    </van-popup>
    <van-popup
      v-model="storeVisible"
      lock-scroll
      closeable
      round
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div class="stb">
        <h3>店铺选择</h3>
        <ul class="ui1">
          <li>LOGO</li>
          <li>店铺名称</li>
          <li>所属品牌</li>
        </ul>
        <ul class="ul2" v-for="item in storeList" :key="item.branchId" @click="changeStoreFHandle(item)">
          <li>
            <div class="img-box"><img :src="item.shopLogoUrl" ></div>
          </li>
          <li class="van-ellipsis li2"><span>{{item.shopName}}</span></li>
          <li class="van-ellipsis li3">{{item.branchName}}</li>
        </ul>
      </div>
    </van-popup>
    <van-popup
      v-model="visibleTimer"
      class="picker-popup"
      position="bottom"
      :overlay="false"
      >
      <div class="content" @click.stop="visibleTimer = false">
        <div class="picker" @click.stop>
          <!-- <van-datetime-picker
            v-model="currentDate"
            title="请选择"
            type="year-month"
            :formatter="formatter"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="visibleTimer = false"
            @confirm="onPickerConfirm"
          /> -->
          <van-cell title="选择日期区间" :value="date" @click="show = true" />
          <van-calendar v-model="visibleTimer" type="range" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
import BOOK from "./components/book";
export default {
  name: '',
  props: {
    
  },
  data() {
    return {
      loading:false,
      time:'1',
      formInline: {
        branchId:'',
        branchName: '',
        shopId: '',
        shopName: '',
        time: '1'
      },
      list_saleStatistics:[],
      list_afterSaleStatistics:[],
      bvisible:false,
      timeFormInline: {
        1: '',
        5: '',
        6: '',
        7: '',
      },
      storeList:[],
      storeVisible: false,
      icon1: require('@/assets/brand/shai@2x.png'),
      icon2: require('@/assets/brand/shai1@2x.png'),
      visibleTimer: false,
      currentDate: new Date(),
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(new Date()),
      formatYM:'',
      date:''
    }
  },
  methods: {
    formatDate(date) {
      let _month = date.getMonth()+1
      let _fullYear = date.getFullYear()
      let _day =date.getDate()
      return `${_fullYear}-${_month < 10? '0'+ _month :_month}-${_day<10? '0'+ _day:_day}`;
    },
    onConfirm(date) {
      let [start, end] = date;
      start = this.formatDate(start);
      end = this.formatDate(end);
      this.visibleTimer = false;
      this.formInline.startTime = start;
      this.formInline.endTime = end;
      this.formatYM = `${start} 至 ${end}`;
      this.setDefaultInitFun()
    },
    initDate(){
      let lod1 = this.saleInit()
      let lod2 = this.afterInit()
      lod1 && lod2 && (this.$loading.hide())
    },
    setParmQuery(){
      let parm = JSON.parse(JSON.stringify(this.formInline))
      delete parm.branchName;
      delete parm.shopName;
      
      parm.time = this.formatYM ? '0' : this.formInline.time
      if(!this.formatYM){
        delete parm.startTime
        delete parm.endTime
      }
      return parm
    },
    async saleInit(){
      let load = false
      let parm = this.setParmQuery()
      await http({
        url: "report/branch/report/saleStatistics",
        method: "post",
        parmes: parm
      })
      .then(rps => {
        if (rps.code === 200) {
          this.list_saleStatistics = rps.data
          load = true
        }
      })
      .catch(rps => {
        this.$loading.hide();
      });
      return load
    },
    async afterInit(){
      let load = false
      let parm = this.setParmQuery()
      await http({
        url: "report/branch/report/afterSaleStatistics",
        method: "post",
        parmes: parm
      })
      .then(rps => {
        if (rps.code === 200) {
          this.list_afterSaleStatistics = rps.data
          load = true
        }
      })
      .catch(rps => {
        this.$loading.hide();
      });
      return load
    },
    handleChange(val){
      if(!val) return
      this.formInline.time = val
      this.formatYM = ''
      this.setDefaultInitFun()
    },
    getNowTime() {
      const now = new Date()
      let year = now.getFullYear() //得到年份
      let month = now.getMonth() //得到月份
      let date = now.getDate() //得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let date_rel = year + '-' + month + '-' + date
      let t90 = this.fun_date(90)
      let t30 = this.fun_date(30)
      let t7 = this.fun_date(7)
      this.timeFormInline['7'] = t90 + ' 至 ' + date_rel
      this.timeFormInline['6'] = t30 + ' 至 ' + date_rel
      this.timeFormInline['5'] = t7 + ' 至 ' + date_rel
      this.timeFormInline['1'] = date_rel + ' 至 ' + date_rel
    },
    fun_date(num) {
      let date1 = new Date()
      let date2 = new Date(date1)
      date2.setDate(date1.getDate() - num)
      //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
      let month = (date2.getMonth() + 1).toString().padStart(2, '0')
      let date = date2.getDate().toString().padStart(2, '0')
      let time2 = date2.getFullYear() + '-' + month + '-' + date
      // console.log(time2)
      return time2
    },
    getBrandData() {
      http({
        url: "order/bee/goods/getBranchInfo",
        method: "POST",
        parmes: {}
      }).then(rps => {
        this.storeList= rps.data;
        let tempList = rps.data.filter((res)=>{return res.isMainShop || []});
        tempList.length> 0 ? this.setQueryParams(tempList[0]) : this.setQueryParams(rps.data[0]);
        this.initDate();
      });
    },
    changeStoreFHandle(row){
      this.setQueryParams(row);
      this.storeVisible = false;
      this.setDefaultInitFun()
    },
    setQueryParams(row){
      for (const key in this.formInline) {
        this.formInline[key] = row[key]  || this.formInline[key]
      }
    },
    setDefaultInitFun(){
      this.$loading.show();
      setTimeout(() => {
        this.initDate()
      }, 500);
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onPickerConfirm(date){
      let times = this.createDate(date).ff
      let {Y, M} = this.createDate(date).ss
      this.formatYM = Y + '年' + M + '月'
      this.formInline.time = ''
      this.visibleTimer = false
      this.setDefaultInitFun()
    },
    createDate(date) {
      const paddingZero = n => n < 10 ? '0' + n : n + '';
      const 
        Y = paddingZero(date.getFullYear()),
        M = paddingZero(date.getMonth() + 1),
        D = paddingZero(date.getDate()),
        h = paddingZero(date.getHours()),
        m = paddingZero(date.getMinutes());

      return {
        ff: [Y, M].join('-'),
        ss: { Y, M, D, h, m, number: Number(Y + M + D + h + m) }
      }
    },
  },
  created() {
    this.getBrandData()
    this.getNowTime()
  },
  mounted(){},
  computed:{},
  components: {BOOK},
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
}
.bsd_heg{
  border-bottom: 1PX solid #F2F2F2;
}
.bsd_tt{
  height: 73px;
  line-height: 73px;
  font-size: 24px;
  color: #999999;
  padding-left: 40px;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.bsd_mov{
  height: 73px;
  background: #FFFFFF;
  display: flex;
  justify-content:space-between;
  font-size: 24px;
  color: #333333;
  line-height: 73px;
  padding-left: 38px;
  padding-right: 38px;
  border-bottom: 1PX solid #F2F2F2;
  >li{
    width: 112px;
    text-align: center;
    position: relative;
    >div{
      position:absolute;
      bottom: 0;
      left: 0;
      width: 112px;
      height: 6px;
      background: var(--epButtonColor);
      border-radius: 3px;
    }
  }
}
.bsd_hed{
  padding-bottom: 20px;
  .bsd_cnt{
    .mar5{
      margin-bottom: 10px;
    }
    .title{
      height: 73px;
      line-height: 73px;
      display: flex;
      justify-content:flex-start;
      background-color: #ffffff;
      position: relative;
      padding-right: 30px;
      .d1{
        width: 100%;
        font-size: 24px;
        color: #333333;
        margin-left: 40px;
        display: flex;
        justify-content: flex-start;
      }
      .c9{
        color: #999999;
      }
      .d2{
        font-size: 24px;
        color: #999999;
        margin-left: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .d3{
        // margin-left: 274px;
        width: 100%;
        text-align: right;
        font-size: 24px;
        color: #999999;
        .img1{
          height: 40px;
          width: 40px;
        }
      }
      .rg_w{
        width: 700px;
      }
      .d4{
        position:absolute;
        right: 0;
        margin-right: 40px;
        font-size: 24px;
        color: #999999;
      }
    }
    .cont-title {
      line-height: normal;
    }
    .cont{
      background-color: #F7F7F7;
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .li{
        display: inline-block;
        width: 345px;
        height: 145px;
        background: #FFFFFF;
        margin-top: 10px;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
        .title{
          font-size: 20px;
          color: #333333;
        }
        .danwei{
          color: #999;
          font-size: 14px;
        }
        .text{
          font-size: 48px;
          color: #F8A651;
        }
      }
    }
  }
  
}
.bsd_mr10{
  margin-top: 10px;
}
.stb{
  padding: 39px 30px 23px 30px;
  font-size: 24px;
  h3{
    font-size: 32px;
    margin-bottom: 31px;
  }
  .ui1{
    display: flex;
    justify-content:space-between;
    background: #F2F2F2;
    height: 81px;
    line-height: 81px;
    padding-left: 22px;
    padding-right: 48px;
    text-align: left;
  }
  .ul2{
    display: flex;
    padding-left: 22px;
    height: 100px;
    line-height:100px;
    li{
      width: 33.3%;
      text-align: left;
      border-bottom:1px solid #F2F2F2;
    }
    .li2{
      margin-right: 100px;
    }
    .li3{
      text-align: center;
    }
    .img-box {
      width: 90px;
      height: 60px;
      margin-top: 20px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.picker-popup {
  background-color: rgba(255, 255, 255, 0)!important;
  .content {
    position: relative;
    height: 100vh;
    /deep/ .van-calendar__day--start{
      background-color: #FFD102;
    }
    /deep/ .van-calendar__day--end{
      background-color: #FFD102;
    }
    /deep/ .van-calendar__day--middle{
      background-color: #FFFAE6;;
    }
  }
  .picker {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 8;
    box-shadow: 0 0 10px #eee;
  }
}
</style>